import { createContext, useContext, useReducer, useCallback } from "react";
import { getEligibility } from "../api/services/eligibilityService";
import { getReports } from "../api/services/reportsService";
import { submitFeedback } from "../api/services/feedbackService";
import { subscribe } from "../api/services/subscribeService";
// import {
//   getEligibility,
//   getReports,
//   submitFeedback,
//   subscribe,
// } from "../api/services";

const initialState = {
  loading: false,
  error: null,
  success: null,
  eligibility: null,
  reports: null,
  showModal: false,
};

const ReportsContext = createContext();

const reportsReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_START":
      return { ...state, loading: true, error: null, success: null };
    case "FETCH_ELIGIBILITY_SUCCESS":
      return { ...state, loading: false, eligibility: action.payload };
    case "FETCH_REPORTS_SUCCESS":
      return { ...state, loading: false, reports: action.payload };
    case "SUBMIT_FEEDBACK_SUCCESS":
      return { ...state, loading: false, success: action.payload };
    case "SUBSCRIBE_SUCCESS":
      return { ...state, loading: false, success: action.payload };
    case "SHOW_MODAL":
      return { ...state, showModal: true };
    case "HIDE_MODAL":
      return { ...state, showModal: false };
    case "ERROR":
      return { ...state, loading: false, error: action.payload };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export const ReportsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reportsReducer, initialState);

  const fetchEligibility = useCallback(async (user_id) => {
    try {
      dispatch({ type: "FETCH_START" });
      const data = await getEligibility(user_id);
      dispatch({ type: "FETCH_ELIGIBILITY_SUCCESS", payload: data });
      return data;
    } catch (error) {
      dispatch({ type: "ERROR", payload: error.message });
      throw error;
    }
  }, []);

  const fetchReports = useCallback(async (user_id) => {
    try {
      dispatch({ type: "FETCH_START" });
      const data = await getReports(user_id);
      dispatch({ type: "FETCH_REPORTS_SUCCESS", payload: data });
      return data;
    } catch (error) {
      dispatch({ type: "ERROR", payload: error.message });
      throw error;
    }
  }, []);

  const sendFeedback = useCallback(async (user_id, message) => {
    try {
      dispatch({ type: "FETCH_START" });
      const response = await submitFeedback(user_id, message);
      dispatch({ type: "SUBMIT_FEEDBACK_SUCCESS", payload: response.message });
      return response;
    } catch (error) {
      dispatch({ type: "ERROR", payload: error.message });
      throw error;
    }
  }, []);

  const subscribeToReports = useCallback(
    async (user_id, subscriptionType, mobile = null) => {
      try {
        dispatch({ type: "FETCH_START" });
        const response = await subscribe(user_id, subscriptionType, mobile);
        dispatch({ type: "SUBSCRIBE_SUCCESS", payload: response.message });
        return response;
      } catch (error) {
        dispatch({ type: "ERROR", payload: error.message });
        throw error;
      }
    },
    []
  );

  const triggerModal = useCallback(() => {
    dispatch({ type: "SHOW_MODAL" });
  }, []);

  const hideModal = useCallback(() => {
    dispatch({ type: "HIDE_MODAL" });
  }, []);

  const resetState = useCallback(() => {
    dispatch({ type: "RESET" });
  }, []);

  return (
    <ReportsContext.Provider
      value={{
        ...state,
        fetchEligibility,
        fetchReports,
        sendFeedback,
        subscribeToReports,
        triggerModal,
        hideModal,
        resetState,
      }}>
      {children}
    </ReportsContext.Provider>
  );
};

export const useReports = () => {
  const context = useContext(ReportsContext);
  if (!context) {
    throw new Error("useReports must be used within a ReportsProvider");
  }
  return context;
};
